export const RECEIVE_SERVER_ERRORS = "RECEIVE_SERVER_ERRORS";
export const SERVER_DOWN_ERROR = "SERVER_DOWN_ERROR";
export const RECEIVE_VALIDATION_ERRORS = "RECEIVE_VALIDATION_ERRORS";
export const RESET_SERVER_ERRORS = "RESET_SERVER_ERRORS";
export const RESET_VALIDATION_ERRORS = "RESET_VALIDATION_ERRORS";
export const RESET_LOADING = "RESET_LOADING";
export const RESET_EMAIL_PASSWORD_ERRORS = "RESET_EMAIL_PASSWORD_ERRORS";

export const resetValidationErrors = () => ({
  type: RESET_VALIDATION_ERRORS,
});

export const receiveValidationErrors = (errors) => ({
  type: RECEIVE_VALIDATION_ERRORS,
  errors,
});

export const resetServerErrors = () => ({
  type: RESET_SERVER_ERRORS,
});

export const receiveServerErrors = (xhr) => ({
  type: RECEIVE_SERVER_ERRORS,
  xhr,
});
